import { useQuery } from 'react-query';

import { getProductivityRiskKPI as queryFn } from 'api/endPoints/getProductivityRiskKPI';
import { QueryResponse } from 'api/endPoints/getScheduleQualityScore/types';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetProductivityRiskKPI = (params) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getProductivityRiskKPI', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId) && Boolean(params.contractId),
    });
};
